import { Toast, Widget } from 'jamespot-front-business';
import jamespot from 'jamespot-user-api';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { useAppDispatch } from '../../../../redux/store';
import { commonComponentsRegistry } from '../../../../registry/CommonRegistry';

const JRCButton = commonComponentsRegistry.getLazyComponent('Button');
const JRCModalLayout = commonComponentsRegistry.getLazyComponent('ModalLayout');
const JRCModalContent = commonComponentsRegistry.getLazyComponent('ModalContent');
const JRCIconButton = commonComponentsRegistry.getLazyComponent('IconButton');

export const Button = styled.button`
    padding: ${(props) => props.theme.space.md}px;
`;

export const Footer = styled.div`
    padding: ${(props) => props.theme.space.md}px;
    display: flex;
    flex-direction: row-reverse;
`;

export const WidgetRemove = ({ id, type, uniqid }: { id: number; type: string; uniqid: string }) => {
    const dispatch = useAppDispatch();
    const intl = useIntl();
    const [isOpen, setIsOpen] = useState<boolean>(false);

    const handleRemove = () => {
        jamespot.widget
            .removeWidget({ id, type, uniqid })
            .then(() => {
                dispatch(Widget.slice.actions.flushWidget({ uniqid }));
            })
            .catch(() => dispatch(Toast.actions.error({ label: 'WIDGET_Presence_Error' })));
    };

    return (
        <>
            <JRCIconButton iconSize={14} onClick={() => setIsOpen(true)} icon="icon-trash" />
            {isOpen && (
                <JRCModalLayout enableClickAwayCloseModal={true} open={isOpen} closeHandler={() => setIsOpen(false)}>
                    <JRCModalContent
                        overflow={'scroll'}
                        title={intl.formatMessage({ id: 'WIDGET_Remove_Widget' })}
                        onClickIconClose={() => setIsOpen(false)}>
                        {intl.formatMessage({ id: 'WIDGET_Delete_Widget_Confirmation' })}
                    </JRCModalContent>
                    <Footer>
                        <JRCButton label={intl.formatMessage({ id: 'GLOBAL_Confirm' })} onClick={handleRemove} />
                    </Footer>
                </JRCModalLayout>
            )}
        </>
    );
};
